export var MENU_ELEMENT_CLASS_PREFIX = 'MenuElement';